export default __webpack_public_path__ + "static/media/noComment.9a6eed15.svg";